export const rootPaths = {
  customer: 'customer',
  details: 'details',
  main: 'main',
  core: 'app',
  summary: 'summary',
  mbb: 'mbb',
  subscription: 'subscription',
  support: 'support',
  login: 'login',
  equipment: 'equipment',
  equipmentupgrade: 'equipmentupgrade',
  sales: 'sales',
  competition: 'competition',
  newsfeed: 'newsfeed',
  battlecards: 'battlecards',
};
